import { render } from "./ViewTour.vue?vue&type=template&id=1989028e&scoped=true"
import script from "./ViewTour.vue?vue&type=script&lang=js"
export * from "./ViewTour.vue?vue&type=script&lang=js"

import "./ViewTour.vue?vue&type=style&index=0&id=1989028e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1989028e"]])

export default __exports__